<div
    class="d-flex flex-column fdx-category-path-wrapper"
    [ngClass]="{ 'gap-2': !showExtraPaths, 'ms-3': pathTypeText }">
    @if (pathTypeText) {
        <div class="fdx-path-type">
            <span class="fw-bold">{{ showingProductType ? 'Item' : 'Product' }} type:</span> {{ pathTypeText }}
        </div>
    }
    @for (path of categoryPaths; track $index) {
        @if (!showExtraPaths || $first || expanded) {
            <div
                [ngClass]="{'mt-1': showExtraPaths && $first, 'ms-3': showExtraPaths || pathTypeText}">
                <div class="fdx-category-path">{{path.path}}</div>
                @if (path.query) {
                    <div class="border-start mt-1 mb-2 ps-3 fdx-category-query">when {{path.query}}</div>
                }
            </div>
        }
    }
    @if (showExtraPaths && categoryPaths.length > 1) {
        <div class="mt-1 ms-3">
            <button
                type="button"
                class="fdx-more-category-paths btn btn-link p-0 white-space-pre"
                [ngClass]="{ 'text-secondary': !expandable }"
                [disabled]="!expandable"
                (click)="toggleExpand()">
                @if (!expanded) {
                    @if (categoryPaths.length - 1 === 1) {
                        +1 more category path
                    } @else {
                        +{{ categoryPaths.length - 1 }} more category paths
                    }
                } @else {
                    Show less
                }
            </button>
        </div>
    }
</div>
